module.exports = __webpack_public_path__ + "media/images/icook-logo@2x-6d2d64b1858042f005e3d8b0d81c6adf.png";